import React, { createContext, useContext, useState, useCallback } from "react";
import { AskAIDrawer } from "@/components/AskAIDrawer";

const AskAIContext = createContext({ open: false, openDrawer: () => {}, closeDrawer: () => {} });

export function useAskAI() { return useContext(AskAIContext); }

export function AskAIProvider({ children }) {
  const [open, setOpen] = useState(false);
  const [pendingPrompt, setPendingPrompt] = useState("");
  const openDrawer = useCallback((prompt) => {
    if (typeof prompt === "string" && prompt) setPendingPrompt(prompt);
    setOpen(true);
  }, []);
  const closeDrawer = useCallback(() => setOpen(false), []);
  const toggleDrawer = useCallback(() => setOpen((o) => !o), []);
  return (
    <AskAIContext.Provider value={{ open, openDrawer, closeDrawer, toggleDrawer }}>
      {children}
      <AskAIDrawer open={open} onClose={closeDrawer} pendingPrompt={pendingPrompt} clearPendingPrompt={() => setPendingPrompt("")} />
    </AskAIContext.Provider>
  );
}
